<template>
 <nav>
            <div>
                <b-navbar variant="faded" type="light" class="unguprimary">
                    <b-navbar-brand href="/home" class="mx-2 text-light">HOSPITAL MANAGEMENT SYSTEM</b-navbar-brand>
                </b-navbar>
            </div>


</nav>
</template>

<script>
export default {
    name: "navbarVue"
}
</script>

<style scoped>
.unguprimary {
    background-color: #50266A;
}
.ungusecondary {
    background-color: #794B93;
}
</style>